<template>
  <div class="bg-brand-light-gray flex flex-col md:py-12">
    <div
      class="
        w-full
        md:max-w-screen-lg
        flex flex-col
        bg-white
        rounded-sm
        shadow
        mx-auto
        py-10
        px-10
        mt-5
      "
    >
      <h2 class="text-2xl py-5">
        Getting Your Account Verified For Credit Reports
      </h2>

      <h2 class="text-2xl py-1">Explanation and Process</h2>
      <Line />
      <p class="py-2 font-light">
        <span class="font-semibold underline"
          >For compliance and information security purposes,</span
        >
        in order to approve your account to request and view credit reports, you
        must submit additional information to Zip Reports.
      </p>

      <p class="py-2 font-light">
        Rent Application is a software platform that works in partnership with
        Zip Reports, the company that ensures the compliance guidelines
        requirements of the Fair Credit Reporting Act are met and requests the
        actual credit reports.
      </p>
      <p></p>

      <p class="py-2 font-semibold underline">
        This only takes about 20 minutes for you
      </p>

      <p class="py-2 font-light">
        Afterwards, you will be able to see
        <span class="font-semibold underline"
          >full credit reports from TransUnion</span
        >
        for your applicants. This includes FICO (credit) score, accounts,
        addresses, aliases and comments from the credit bureau.
      </p>

      <p class="py-2 font-light">
        Please direct any questions regarding the requirements, process, and
        timeline for approval to:
      </p>
      <p class="py-2 font-light">
        Zip Reports<br />
        800-311-1585 <br />
        service@zipreports.com
      </p>
      <h2 class="text-2xl py-1">Required Documents</h2>
      <Line />

      <p class="py-2 font-light">
        Here are the documents that must be completed:
      </p>

      <ol class="list-decimal px-5">
        <li class="font-light py-1 px-1">
          <p class="py-2 font-light">
            First,
            <a
              class="text-brand-green cursor-pointer"
              target="_blank"
              href="https://zipreports.com/zipapp.php?apptype=pg_company&promocode=RL0414"
            >
              complete this online application form.</a
            >
            This will certify you to be the end user of credit reports, which
            means that you or your company are aiding in evaluating the
            applicant to ensure that he or she is a qualified tenant.
          </p>
          <p>Here's the direct link:</p>
          <a
            class="text-brand-green cursor-pointer"
            target="_blank"
            href="https://zipreports.com/zipapp.php?apptype=pg_company&promocode=RL0414"
            >https://zipreports.com/zipapp.php?apptype=pg_company&promocode=RL0414</a
          >
        </li>
        <li class="font-light py-1 px-1">
          Second, complete this site inspection form. The inspection form should
          be completed by
          <span class="underline"
            >someone other than yourself, a family member, or an employee of
            your company.</span
          >
          After completing it, email it to
          <a
            class="text-brand-green cursor-pointer"
            mailto="service@zipreports.com"
            >service@zipreports.com</a
          >
          or fax it directly to 818-583-1756. <br />Click here to download it:
          <a
            class="text-brand-green cursor-pointer"
            href="docs/ACRANET-SiteInspectionForm0215.pdf"
            >Self-completed Site Inspection Form</a
          >
          <br />
          If you need an online document editor, we recommend using
          www.HelloSign.com, a free service which allows you to complete and
          sign the document in your browser.
        </li>
      </ol>

      <p class="py-2 font-light">
        After that, it will be reviewed by the compliance department at Zip
        Reports and you will be notified when your account is approved for
        processing credit reports.
      </p>

      <p class="py-2 font-semibold">
        If you're a licensed property management or real estate company, the
        above documents will probably be sufficient to establish permissible
        purpose for requesting credit reports.
      </p>

      <p class="py-2 font-light">
        If you are an individual, non-professional landlord, or have a real
        estate license as an individual and are required to operate under the
        umbrella of another managing broker's license, Zip Reports may require
        additional information in order to authorize you to view credit reports.
        Once you've completed the above 2 documents, Zip Reports will notify you
        of what they need to complete the application process. The most commonly
        requested documents in order to expedite the process are:
      </p>

      <ol class="list-decimal px-5">
        <li class="font-light py-1 px-1">Copy of your Driver's License</li>
        <li class="font-light py-1 px-1">
          Authorization to obtain your credit report, form here:
          <a
            href="http://www.zipreports.com/forms/Credit_Authorization.pdf"
            target="_blank"
            class="text-brand-green cursor-pointer"
            >http://www.zipreports.com/forms/Credit_Authorization.pdf</a
          >
          (only run in the case of a credit bureau audit of your account, this
          is extremely rare).
        </li>
        <li class="font-light py-1 px-1">
          Proof of ownership of at least one of your rental properties (tax
          bill, insurance document, link to county tax assessor website
          displaying your name and property address, etc.).
        </li>
      </ol>

      <p class="py-2 font-light">
        After completing the online form in step 1, email ALL remaining
        documents to
        <a
          class="text-brand-green cursor-pointer"
          mailto="service@zipreports.com"
          >service@zipreports.com</a
        >
        with your Name and company name (if applicable) in the subject.
      </p>

      <h2 class="text-2xl py-1">Questions</h2>
      <Line />
      <p class="py-2 font-light">
        If you have questions or need further clarification, please contact us
        directly at
        <a class="text-brand-green cursor-pointer" :mailto="supportEmail">{{
          supportEmail
        }}</a>
      </p>
    </div>
  </div>
  <Footer />
</template>
